import AtendimentoOnline from 'pages/AtendimentoOnline'
import ManualUsuario from 'pages/ManualUsuario'
import React from 'react'
import { RouteObject } from 'react-router-dom'
const PrimeirosPassos = React.lazy(() => import('pages/PassoPasso'))

const base = '/ajuda'

export const ajuda: RouteObject = {
    path: base,
    children: [
        {
            path: base + '/atendimento-online',
            element: <AtendimentoOnline />,
        },
        {
            path: base + '/manual',
            element: <ManualUsuario />,
        },
        {
            path: base + '/primeiros-passos',
            element: <PrimeirosPassos />,
        },
    ],
}
